import React from "react";
// Limitless imports
import AttachmentBody from "../../attachment-body/AttachmentBody";
import CustomerDialogueWrapper from "./CustomerDialogueWrapper";
import CustomerDialogueBody from "./CustomerDialogueBody";

var CustomerAttachmentDialogue = function CustomerAttachmentDialogue(_ref) {
  var dialogue = _ref.dialogue,
      shouldAnimate = _ref.shouldAnimate;
  var body = dialogue.body,
      attachments = dialogue.attachments;
  return /*#__PURE__*/React.createElement(CustomerDialogueWrapper, {
    dialogue: dialogue,
    shouldAnimate: shouldAnimate
  }, function () {
    return /*#__PURE__*/React.createElement("div", null, attachments && attachments.map(function (attachment, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement(AttachmentBody, {
        attachment: attachment,
        isCustomer: true
      }));
    }), typeof body === "string" && /*#__PURE__*/React.createElement(CustomerDialogueBody, {
      body: body
    }));
  });
};

export default CustomerAttachmentDialogue;